import React, { useMemo, useState, useEffect, Component } from 'react';
import { Row, Col } from 'antd';
import Swal from 'sweetalert2';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem } from '@mui/material';
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';

import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import axios from 'axios';
//import { useNavigate } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import DynamicTable from '../Reusable/DynamicTable';
import CustomTextField from "../Reusable/Numerictext";
import CustomSwitch from '../Reusable/CustomSwitch';
import CustomButton from '../Reusable/CustomButton'
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import Autocomplete from '@mui/material/Autocomplete';
import { useNavigate } from "react-router-dom";
import {Backdrop, CircularProgress, } from '@mui/material';

import { BASE_URL } from '../../App'
const Example = () => {
    const navigate = useNavigate();
    var LOGINID = localStorage.getItem('LOGIN_ID')
    var BRANCHCODE = localStorage.getItem('BRANCH_CODE')
    //dropdownbox
    const [branchList, setBranchList] = useState([]);
    const [functionList, setFunctionList] = useState([]);
    const [userList, setUserList] = useState([]);
    //view
    const [viewingRow, setViewingRow] = useState(null)
    const [viewData, setViewedData] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
    //crewte and edit 
    const [isCreateUserPopupOpen, setCreateUserPopupOpen] = useState(false);
    const [editedRowData, setEditedRowData] = useState(null);
    const [editingRow, setEditingRow] = useState(null);
    const [isViewPopupOpen, setViewPopupOpen] = useState(false);
    //const [editedUser, setEditedUser] = useState({ Active: 0 });
    const [toggleState, setToggleState] = useState(false);
    const [editedUser, setEditedUser] = useState({ LOGIN_ID: '' });
    const [loading, setloading] = React.useState(false);
    const Level = [
        "1",
        "2",
        "3",

    ];
    //get dropdown data
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const response = await axios.post(BASE_URL + '/functionalapprovalsettingforview', {
    //                 login_id: LOGINID
    //             });
    //             const responseData = response.data;
    //             const branch = responseData.branchlist || [];
    //             setBranchList(branch);
    //             const Functionname = responseData.functionname || [];
    //             setFunctionList(Functionname);
    //             const LoginID = responseData.userlist || [];
    //             setUserList(LoginID);
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //         }
    //     };
    //     fetchData();
    // }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(`${BASE_URL}/functionalapprovalsettingforview`, {
                    login_id: LOGINID
                });
                const responseData = response.data;
                console.log('Response Data:', responseData);

                const branch = responseData.branchlist || [];
                setBranchList(branch);
                const functionname = responseData.functionname || [];
                setFunctionList(functionname);
                const userlist = responseData.userlist || [];
                setUserList(userlist);
                console.log('User List:', userlist);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleCreateUser = async ({ values, row, table }) => {
        setValidationErrors({});
        fetchData();
    };
    const handleSaveUser = async ({ values, table }) => {
        setValidationErrors({});
        table.setEditingRow(null);
        fetchData();
    };
    const handleSwitchChange = (value) => {
        // Handle the switch value here
        console.log('Switch value:', value);
    };
    function useGetUsers() {
        return useQuery({
            queryKey: ['users'],
            queryFn: async () => {
                await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
            },
            refetchOnWindowFocus: false,
        });
    }
    const closeViewDataPopup = () => {
        // Close the view data popup
        setViewPopupOpen(false);
    };
    const handleClose = () => {
        setViewingRow(null);
        setViewPopupOpen(false);
    };
    const ViewDataPopup = ({ data, onClose }) => {
        // Customize this component to display the data in input boxes


        return (

            <Dialog open={true} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle >View Function</DialogTitle>

                <DialogContent>
                    <Row>
                        <Col xs={22} sm={10}>
                            <CustomTextField

                                label="Branch"
                                fullWidth
                                value={data.NAME}
                                margin="normal"
                                InputProps={{ readOnly: true }}
                            />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>

                            <CustomTextField label="Function Name" fullWidth value={data.FUNCTION_DESC} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <CustomTextField label="From Value" fullWidth value={data.FROM_VALUE} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <CustomTextField label="To Value" fullWidth value={data.TO_VALUE} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <CustomTextField label="Level" fullWidth value={data.LEVEL_NO} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <CustomTextField label="Login Id" fullWidth value={data.LOGIN_ID} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} sm={11}>
                            <div>Value Based</div>
                            <Switch
                                label="Value Based"
                                checked={data.VALUEBASED === '1'}
                                name="VALUEBASED"
                                color="primary"

                            />
                        </Col>
                        <Col xs={24} sm={11}>
                            <div>ACTIVE</div>
                            <Switch
                                label="ACTIVE"
                                checked={data.ACTIVE === '1'}
                                name="ACTIVE"
                                color="primary"
                            />
                        </Col>
                    </Row>
                    <Row>
                    </Row>
                </DialogContent>

                <DialogActions>

                    <CustomButton
                        label="Close"
                        onClick={handleClose}
                        variant="outlined"
                    />

                </DialogActions>
            </Dialog>
        );
    };
    const EditUserPopup = ({ user, onSave, onClose }) => {
        const [editedUser, setEditedUser] = useState({ ...user, VALUEBASED: 0, ACTIVE: 0, });
        const [selecteditedUser, setselectEditedUser] = useState({ ...user });
        const isValueBased = editedUser.VALUEBASED === "1";

        useEffect(() => {
            if (user) {
                setEditedUser({
                    ...user,
                });
            }
        }, [user]);
        const data = {
            branch_code: editedUser.BRANCH_CODE,
            function_code: editedUser.FUNCTION_CODE,
            from_value: editedUser.FROM_VALUE,
            to_value: editedUser.TO_VALUE,
            level_no: editedUser.LEVEL_NO,
            user_id: editedUser.LOGIN_ID,
            active: editedUser.ACTIVE,
            valuebased: editedUser.VALUEBASED,
            login_id: LOGINID
        };
        const update = {
            login_id: LOGINID,
            value_based: editedUser.VALUEBASED,
            from_value: editedUser.FROM_VALUE,
            to_value: editedUser.TO_VALUE,
            active: editedUser.ACTIVE,
            branch_code: editedUser.BRANCH_CODE,
            function_code: editedUser.FUNCTION_CODE,
            level_no: editedUser.LEVEL_NO,
            user_id: editedUser.LOGIN_ID,
            previous_user_id: localStorage.getItem('previous_LOGIN_ID')
        };
        const handleToggleChange = async (event) => {
            try {
                const newvalue = event.target.checked ? 1 : 0;
                setToggleState(event.target.checked);
            } catch (error) {
                console.error('Error updating toggle state:', error);
            }
        };
        const handleChange = (fieldName) => (event) => {
            const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
            if (fieldName === 'LOGIN_ID' && editedUser.LOGIN_ID) {
                localStorage.setItem('previous_LOGIN_ID', editedUser.LOGIN_ID);
            }
            //alert(localStorage.getItem('previous_LOGIN_ID'));
            setEditedUser((prev) => ({ ...prev, [fieldName]: value }));
            setInputs({ ...inputs, [event.target.name]: event.target.value });
            setEditedUser({
                ...editedUser,
                [fieldName]: value,
            });
            if (fieldName === 'Active' || fieldName === 'VALUEBASED') {
                setEditedUser({
                    ...editedUser,
                    [fieldName]: value ? 1 : 0,// Assuming the switch value is 1 or 0
                });
            }
        };
        const [isSwitchEnabled, setIsSwitchEnabled] = useState(true);
        const [inputs, setInputs] = useState({
            BRANCH_CODE: '', FUNCTION_CODE: '', FROM_VALUE: '', TO_VALUE: '', LEVEL_NO: '', LOGIN_ID: '', ACTIVE: '', CREATEDBY: 'ADMIN'
        });
        let message;
        const [selectedItem, setSelectedItem] = useState({ CODE: '', name: '' });
        const handleSave = async () => {
            try {
                let response;
                if (user) {

                    response = await axios.post(BASE_URL + '/functionalapprovalsettingupdate', update);
                } else {
                    response = await axios.post(BASE_URL + '/functionalapprovalsettingcreate', data);
                }

                Swal.fire({
                    icon: 'success',
                    text: response.data.text || 'Data saved successfully!',
                    customClass: {
                        popup: 'my-swal-popup',
                        htmlContainer: 'z-index: 99999 !important;'// Add a custom class to the popup
                    }
                });

                onSave(editedUser);
                onClose();

            } catch (error) {

                console.error('Error inserting data:', error);
                if (error.response) {
                    const errorMessages = error.response.data.message;
                    const errorMessageList = errorMessages.map((message, index) => `${index + 1}. ${message}`).join('\n');
                    Swal.fire({
                        allowOutsideClick: false,
                        position: 'top-end',
                        icon: 'error',
                        title: 'Error',
                        text: errorMessageList,
                        timer: 3000,
                        showConfirmButton: false,
                        timerProgressBar: true,
                        customClass: {
                            popup: 'my-swal-popup',
                            htmlContainer: 'z-index: 99999 !important;width: 200px;'// Add a custom class to the popup
                        }


                    });
                } else if (error.request) {

                    Swal.fire({
                        allowOutsideClick: false,
                        position: 'top-end',
                        icon: 'error',
                        title: 'Error',
                        text: 'No response received from the server.',
                        timer: 3000,
                        showConfirmButton: false,
                        timerProgressBar: true,

                    });
                } else {

                    Swal.fire({
                        allowOutsideClick: false,
                        position: 'top-end',
                        icon: 'error',
                        title: 'Error',
                        text: 'Error setting up the request. Please try again.',
                        timer: 3000,
                        showConfirmButton: false,
                        timerProgressBar: true,

                    });
                }
            }
            // onSave(editedUser);
            // onClose();
        };
        const branch_option = branchList ? branchList.map((functionListitem) => ({
            Value: functionListitem.CODE,
            Label: functionListitem.name,
        })) : [];
        const function_option = functionList ? functionList.map((branchItem) => ({
            Value: branchItem.FUNCTION_CODE,
            Label: branchItem.DESCRIPTION,
        })) : [];
        const user_option = userList ? userList.map((userlistItem) => ({
            Value: userlistItem.LOGINID,
            Label: userlistItem.LOGINNAME,
        })) : [];


    // const user_option = userList.map((userlistItem) => ({
    //     Value: userlistItem.LOGINID,
    //     Label: userlistItem.LOGINNAME,
    // }));
        const [initialUserChanged, setInitialUserChanged] = useState(false);

        const handleLoginIdChange = (newValue) => {
            if (!initialUserChanged) {
                localStorage.setItem('previous_LOGIN_ID', editedUser.LOGIN_ID);
                setInitialUserChanged(true);
            }
            setEditedUser({ ...editedUser, LOGIN_ID: newValue });
        };
        return (
            <form>
                <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth BackdropProps={{ invisible: true }} >
                    <DialogTitle>
                        <u>
                            <b>{user ? 'Edit Function' : 'Create New Function'}</b>
                        </u>
                    </DialogTitle>
                    <DialogContent>
                        <Row>
                            <Col xs={22} sm={10}>

                                {!!user ? (
                                    <SelectNormal
                                        readOnly={true}
                                        label="Branch"
                                        name="branch"
                                        options={branch_option}
                                        value={editedUser.BRANCH_CODE || ''}
                                        onChange={(newValue) => handleChange('BRANCH_CODE')}
                                    //   onChange={handleChange('BRANCH_CODE')}

                                    // onChange={(e) => setEditedUser({ ...editedUser, CODE: e.target.value })}
                                    />
                                ) : (
                                    <SelectSearch

                                        label="Branch"
                                        name="branch"
                                        options={branch_option}
                                        value={editedUser.BRANCH_CODE || ''}
                            
                                        onChange={(newValue) => setEditedUser({ ...editedUser, BRANCH_CODE: newValue })}

                                   
                                    />




                                )}



                            </Col>
                            <Col xs={4} sm={2}></Col>
                            <Col xs={22} sm={10}>

                                {!!user ? (
                                    <SelectNormal
                                        readOnly={true}
                                        label="Function Name"
                                        name="FUNCTION_CODE"
                                        options={function_option}
                                        value={editedUser.FUNCTION_CODE || ''}
                                        // onChange={handleChange('FUNCTION_CODE')}
                                        onChange={(newValue) => handleChange('FUNCTION_CODE')}
                                    />
                                ) : (

                                    <SelectSearch
                                        label="Function Name"
                                        name="FUNCTION_CODE"
                                        options={function_option}
                                        value={editedUser.FUNCTION_CODE || ''}
                                        onChange={(newValue) => setEditedUser({ ...editedUser, FUNCTION_CODE: newValue })}

                                    />
                                )}


                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={11}>
                                <lebel>Active</lebel>
                                <Switch
                                    label="ACTIVE"
                                    checked={editedUser.ACTIVE === "1"}
                                    //checked={editedUser.Active === "1"}
                                    onChange={(e) => setEditedUser({ ...editedUser, ACTIVE: e.target.checked ? "1" : "0" })}
                                    name="ACTIVE"
                                    color="primary"
                                />



                            </Col>
                            <Col xs={24} sm={11}>

                                <lebel>   Value Based</lebel>
                                <Switch
                                    label="VALUEBASED"
                                    checked={editedUser.VALUEBASED === "1"}
                                    onChange={(e) => setEditedUser({ ...editedUser, VALUEBASED: e.target.checked ? "1" : "0" })}
                                    name="VALUEBASED"
                                    color="primary"

                                />


                            </Col>
                        </Row>
                        {editedUser.VALUEBASED === "1" ? (
                            <Row>
                                <Col xs={22} sm={10}>

                                    <CustomTextField
                                        label="From Value"
                                        name="FROM_VALUE"
                                        type="number"

                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 14);
                                        }}
                                        inputProps={{
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                            style: { MozAppearance: 'textfield', appearance: 'textfield' },
                                        }}


                                        value={editedUser.FROM_VALUE}
                                        onChange={handleChange('FROM_VALUE')}

                                        disabled={editedUser.VALUEBASED !== "1"}
                                    >

                                    </CustomTextField>
                                </Col>
                                <Col xs={4} sm={2}></Col>
                                <Col xs={22} sm={10}>

                                    <CustomTextField
                                        label="To Value"
                                        name="TO_VALUE"
                                        type="number"

                                        value={editedUser.TO_VALUE}
                                        //  value={editedUser.VALUEBASED === "1" ? editedUser.TO_VALUE : "0"}
                                        onChange={handleChange('TO_VALUE')}

                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 14);
                                        }}
                                        inputProps={{
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                            style: { MozAppearance: 'textfield', appearance: 'textfield' },
                                        }}


                                        disabled={editedUser.VALUEBASED !== "1"}
                                    >

                                    </CustomTextField>

                                </Col>
                            </Row>
                        ) : (<></>)}
                        <Row>
                            <Col xs={22} sm={10}>


                                {!!user ? (
                                    <CustomTextField
                                        disabled
                                        label="Level"
                                        name="LEVEL_NO"
                                        fullWidth
                                        select
                                        value={editedUser.LEVEL_NO || ''}

                                        onChange={handleChange('LEVEL_NO')}

                                        margin="normal"
                                    >
                                        {Level.map((Level) => (
                                            <MenuItem key={Level} value={Level}>
                                                {Level}
                                            </MenuItem>
                                        ))}
                                    </CustomTextField>
                                ) : (
                                    <CustomTextField
                                        label="Level"
                                        name="LEVEL_NO"
                                        fullWidth
                                        select
                                        value={editedUser.LEVEL_NO || ''}

                                        onChange={handleChange('LEVEL_NO')}

                                        margin="normal"
                                    >
                                        {Level.map((Level) => (
                                            <MenuItem key={Level} value={Level}>
                                                {Level}
                                            </MenuItem>
                                        ))}
                                    </CustomTextField>
                                )}

                            </Col>
                            <Col xs={4} sm={2}></Col>
                            <Col xs={22} sm={10}>
                                <SelectSearch
                                    label="Login Id"
                                    name="LOGIN_ID"
                                    options={user_option}
                                    value={editedUser.LOGIN_ID || ''}
                                    // value={editedUser?.LOGIN_ID} 
                                    //  onChange={handleChange('LOGIN_ID')}
                                    onChange={handleLoginIdChange}
                                // onChange={handleUserChange()}
                                //search={true}
                                />
                           </Col>
                        </Row>
                        <center>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                                        <CustomButton
                                            label={user ? 'Save' : 'Create'}
                                            onClick={handleSave}
                                            variant="outlined"
                                            size="medium"
                                            height={40}
                                            width="200px"
                                            borderRadius="8px"
                                            type="submit"
                                            sx={{ flexGrow: 1 }}
                                        />
                                        <CustomButton
                                            label="Cancel"
                                            onClick={onClose}
                                            variant="outlined"
                                            size="medium"
                                            height={40}
                                            width="200px"
                                            borderRadius="8px"
                                            type="submit"
                                            sx={{ flexGrow: 1 }}
                                            color="error"
                                        />
                                    </Stack>
                                    <br />
                                </div>
                            </Typography>
                        </center>
                    </DialogContent>
                </Dialog>
            </form >
        );
    };
    const [tableData, setTableData] = useState([]);
   // const branchname = BRANCHCODE;
    const loginids = LOGINID;
    //const functionid = '';
    const fetchData = () => {
        setloading(true);

        axios.post(BASE_URL + '/functionalapprovalsettinglist', {

           // branch_code: branchname,
            login_id: loginids,
           // function_code: functionid,
        })
        
            .then(response => {
                setloading(false);

                if (response.status === 200) {
                    setTableData(response.data.functionalapprovalsettinglist);
                } else {
                    console.error('Unexpected status code:', response.status);
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });
    }
    const Branch_code = localStorage.getItem("BRANCH_CODE");
    const login_id = localStorage.getItem("LOGIN_ID");
    
    useEffect(() => {
        if (!login_id || !Branch_code) {
            Swal.fire({
                icon: "warning",
                text: 'Login Failed !'
            });
            localStorage.clear()
            navigate('/')
            navigate('/Login')
        } else {
            fetchData();
        }
    }, []);
    const openCreateUserPopup = (rowData) => {
        setCreateUserPopupOpen(true);
        setEditedRowData(rowData);
    };
    const handleViewEditClick = (rowData) => {

        setViewedData(rowData);
        setViewPopupOpen(true);
    };
    return (
        <>
            <DynamicTable data={tableData} onEditClick={openCreateUserPopup} onViewClick={handleViewEditClick} />;
            {/* <MaterialReactTable table={table} /> */}
            {editingRow && (
                <EditUserPopup
                    user={editingRow.original}
                    onSave={(editedData) => {
                        handleSaveUser({ values: editedData, tableData });
                    }}
                    onClose={() => setEditingRow(null)}
                />
            )}
            {isCreateUserPopupOpen && (

                <EditUserPopup
                    user={editedRowData}
                    onSave={handleCreateUser}
                    onClose={() => {
                        setCreateUserPopupOpen(false);
                        setEditedRowData(null); // Clear the edited row data when closing the popup
                    }}
                />
            )}
            {isViewPopupOpen && (
                <ViewDataPopup
                    data={viewData}
                    onClose={closeViewDataPopup}
                />
            )}
            
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
    );
};
const queryClient = new QueryClient();
const ExampleWithProviders = () => (
    <QueryClientProvider client={queryClient}>
        <Example />
    </QueryClientProvider>
);
export default ExampleWithProviders;